var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconos2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 27,
    viewBox: "0 0 268 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0783 15.8329H1.1283C0.676991 15.8329 0.300903 15.4504 0.300903 14.9915C0.300903 14.5326 0.676991 14.1501 1.1283 14.1501H27.0783C27.5296 14.1501 27.9057 14.5326 27.9057 14.9915C27.9057 15.4504 27.5296 15.8329 27.0783 15.8329Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04834 25.0114V25.8527C8.04834 26.3116 8.42443 26.6941 8.87573 26.6941C9.32704 26.6941 9.70313 26.3116 9.70313 25.8527V25.3938C9.1766 25.3173 8.65008 25.1643 8.04834 25.0114Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4283 25.3173V25.7762C18.4283 26.2351 18.8044 26.6175 19.2557 26.6175C19.707 26.6175 20.0831 26.2351 20.0831 25.7762V24.9348C19.5566 25.1643 19.0301 25.3173 18.4283 25.3173Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48218 14.1501V3.90081C2.48218 1.91214 4.06175 0.305908 6.0174 0.305908C7.14566 0.305908 8.12349 0.841319 8.80045 1.68268C9.8535 1.60619 10.9065 2.21809 11.2826 3.21242V3.3654C11.4331 3.67135 11.2826 4.05378 10.9065 4.20676L7.59697 5.50704C7.2961 5.66002 6.92001 5.50704 6.76958 5.12461L6.69436 4.97163C6.31827 4.05378 6.61914 2.98296 7.2961 2.29458C6.92001 1.98863 6.46871 1.83565 6.0174 1.83565C4.88914 1.83565 3.98653 2.7535 3.98653 3.90081V14.1501",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8266 25.3937H10.3048C6.0174 25.3937 2.48218 21.7988 2.48218 17.3625V15.8328H25.7244V17.3625C25.7244 21.7988 22.1892 25.3937 17.8266 25.3937Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.491 10.0963L176.987 11.626C176.686 11.932 176.31 11.932 176.009 11.626C169.691 5.73651 159.912 5.73651 153.594 11.626C153.293 11.8555 152.917 11.8555 152.616 11.626L151.112 10.0963C150.811 9.79033 150.811 9.33141 151.112 9.10195C158.784 1.91214 170.669 1.91214 178.341 9.10195C178.792 9.33141 178.792 9.79033 178.491 10.0963ZM173.677 15.068L172.173 16.5977C171.947 16.8272 171.496 16.9036 171.195 16.5977C167.585 13.3852 162.094 13.3852 158.483 16.5977C158.182 16.8272 157.806 16.8272 157.505 16.5977L156.001 15.068C155.7 14.762 155.7 14.3031 156.001 14.0736C160.965 9.56087 168.562 9.56087 173.527 14.0736C173.903 14.3031 173.978 14.762 173.677 15.068ZM167.66 20.575C167.66 22.1048 166.456 23.4051 164.877 23.4051C163.297 23.4051 162.094 22.1813 162.094 20.575C162.094 18.9688 163.297 17.745 164.877 17.745C166.456 17.745 167.66 18.9688 167.66 20.575Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7219 12.8498V3.21241C76.7219 2.44754 76.1202 1.75916 75.2928 1.75916H54.608C53.8558 1.75916 53.1788 2.44754 53.1788 3.21241V12.8498",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6023 21.9518H51.2983V14.3031C51.2983 13.5382 51.9001 12.8499 52.7275 12.8499H77.1732C77.9253 12.8499 78.6023 13.4618 78.6023 14.3031V21.9518V21.9518Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.988 12.8498V10.3257C64.988 8.64301 63.634 7.26624 61.9793 7.26624H56.2627C54.6079 7.26624 53.254 8.64301 53.254 10.3257V12.8498",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7218 12.8498V10.3257C76.7218 8.64301 75.3679 7.26624 73.7131 7.26624H67.9966C66.3418 7.26624 64.9879 8.64301 64.9879 10.3257V12.8498",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8557 21.9518H51.2983V24.4759C51.2983 24.8583 51.5992 25.2407 52.0505 25.2407H53.1036C53.4796 25.2407 53.8557 24.9348 53.8557 24.4759V21.9518Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6023 21.9518H76.0449V24.4759C76.0449 24.8583 76.3458 25.2407 76.7971 25.2407H77.8501C78.2262 25.2407 78.6023 24.9348 78.6023 24.4759V21.9518Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.343 11.3201H102.296C101.694 11.3201 101.168 10.7846 101.168 10.1727V3.74781C101.168 2.98294 101.769 2.29456 102.597 2.29456H127.042C127.795 2.29456 128.472 2.90645 128.472 3.74781V10.2492C128.472 10.8611 127.945 11.3201 127.343 11.3201Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.198 8.87244H126.365",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.079 17.5155C105.079 19.2747 106.508 20.6515 108.163 20.6515C109.893 20.6515 111.247 19.1983 111.247 17.5155V11.3201",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 20.1161C124.56 21.8753 123.131 23.2521 121.476 23.2521C119.746 23.2521 118.392 21.7988 118.392 20.1161V11.3201",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.782 11.3201V24.7053",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.458 20.0397H202.41C201.809 20.0397 201.282 19.5043 201.282 18.8924V5.50709C201.282 4.74222 201.884 4.05383 202.711 4.05383H227.157C227.909 4.05383 228.586 4.66573 228.586 5.50709V18.9688C228.586 19.5807 228.06 20.0397 227.458 20.0397Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.896 20.0397V22.9462",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.751 22.9462H222.117",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.323 7.41927L263.261 11.5496V23.2521C263.261 24.017 262.66 24.6289 261.907 24.6289H261.23C260.478 24.6289 259.877 24.017 259.877 23.2521V18.357H259.2V23.2521C259.2 24.017 258.598 24.6289 257.846 24.6289H257.169C256.417 24.6289 255.815 24.017 255.815 23.2521V11.6261L251.753 7.49576C251.227 6.96035 251.227 6.0425 251.753 5.50709C252.28 4.97168 253.182 4.97168 253.709 5.50709L257.47 9.33145H261.832L265.593 5.50709C266.12 4.97168 267.022 4.97168 267.549 5.50709C267.925 6.0425 267.925 6.88386 267.323 7.41927ZM259.425 2.21814C261.155 2.21814 262.509 3.6714 262.509 5.35412C262.509 7.03684 261.08 8.4901 259.425 8.4901C257.77 8.4901 256.341 7.03684 256.341 5.35412C256.341 3.6714 257.695 2.21814 259.425 2.21814Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos2);
export default __webpack_public_path__ + "static/media/iconos2.9a45b2c570d290d94433f99901496537.svg";
export { ForwardRef as ReactComponent };